var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinterest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 21,
    viewBox: "0 0 12 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.375 3.21875C9.3125 3.21875 12 5.25 12 8.34375C12 11.25 10.5 14.5 7.1875 14.5C6.375 14.5 5.40625 14.0938 5 13.375C4.3125 16.1875 4.34375 16.625 2.78125 18.7812C2.625 18.8438 2.65625 18.8438 2.5625 18.7188C2.5 18.125 2.4375 17.5625 2.4375 16.9688C2.4375 15.0625 3.3125 12.2812 3.75 10.4375C3.5 9.9375 3.4375 9.375 3.4375 8.84375C3.4375 6.34375 6.375 5.96875 6.375 8.03125C6.375 9.25 5.53125 10.4062 5.53125 11.5938C5.53125 12.375 6.21875 12.9375 7 12.9375C9.15625 12.9375 9.8125 9.84375 9.8125 8.1875C9.8125 5.96875 8.25 4.75 6.09375 4.75C3.625 4.75 1.71875 6.53125 1.71875 9.03125C1.71875 10.25 2.46875 10.875 2.46875 11.1562C2.46875 11.4062 2.28125 12.25 1.96875 12.25C1.21875 12.25 0 11 0 8.8125C0 5.34375 3.15625 3.21875 6.375 3.21875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterest);
export default __webpack_public_path__ + "static/media/pinterest.71f8ae15f946739c9546d4c784e3fa84.svg";
export { ForwardRef as ReactComponent };